import { PartnerProvider } from '@/shared/providers/partner'
import { RenderContextProvider } from '@/shared/contexts/RenderContext'
import { TenantProvider } from '@/shared/contexts/TenantContext'

import { AbilityProvider } from './AbilityProvider'
import { CookiesProvider } from './CookiesProvider'
import { DataProvider } from './DataProvider'
import { ModalProvider } from './ModalProvider'
import { NextAuthSessionProvider } from './NextAuthSessionProvider'
import { QueryProvider } from './QueryProvider'
import { DebugPanelRoot } from '@/shared/lib/debug-panel/DebugPanelRoot'
import { DevEnvironmentBadge } from '@/shared/ui/DevEnvironmentBadge'

import { SessionProvider } from './SessionProvider'

export const Providers = ({
  session,
  dehydratedState,
  initialUserAgent,
  initialIsIframe,
  children
}) => {
  return (
    <NextAuthSessionProvider
      session={session}
      staleTime={5 * 60}
      clientMaxAge={5 * 60}
      refetchInterval={0}
      refetchOnWindowFocus={false}
    >
      <QueryProvider dehydratedState={dehydratedState}>
        <TenantProvider>
        <CookiesProvider>
          <RenderContextProvider
            initialUserAgent={initialUserAgent}
            initialIsIframe={initialIsIframe}
            fallback={
              <div className="flex justify-center items-center min-h-screen w-screen">
                <div className="w-8 h-8 border-2 border-gray-300 border-t-gray-600 rounded-full animate-spin" role="status" />
              </div>
            }
          >
            <PartnerProvider>
              <AbilityProvider>
                <DataProvider>
                  <SessionProvider>
                    <ModalProvider>
                      {children}
                      <DevEnvironmentBadge />
                      <DebugPanelRoot />
                    </ModalProvider>
                  </SessionProvider>
                </DataProvider>
              </AbilityProvider>
            </PartnerProvider>
          </RenderContextProvider>
        </CookiesProvider>
        </TenantProvider>
      </QueryProvider>
    </NextAuthSessionProvider>
  )
}
